import gsap from 'gsap';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';
import { Lang } from '../common/lang';

export default class FormScreen {
  constructor(camera, canvas) {
    this.bool = false;
  }
  init() {
    this.isSubmitted = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    document.querySelector('#submit').addEventListener('click', () => {
      if (this.isSubmitted) return;
      Global.soundEnabled && document.querySelector('#tapAudio').play();
      this.onSubmit();
    });
    document.getElementById('country').addEventListener('change', (e) => {
      if (this.isSubmitted) return;
      this.changeCountry(e.target.value);
    });
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'FormScreen') return false;

    document.querySelector('#form_screen').classList.add('active');
    gsap.delayedCall(0.0, () => {
      document.querySelector('#form_screen').classList.add('active2');
    });
    gsap.delayedCall(0.2, this.animateScreen.bind(this));
  }
  animateScreen() {
    gsap.delayedCall(0.0, () => {
      document.querySelector('#form_screen .logo').classList.add('active');
    });
    gsap.delayedCall(0.2, () => {
      document.querySelector('#form_screen #details').classList.add('active');
    });
    gsap.delayedCall(0.3, () => {
      document
        .querySelector('#form_screen .inputContainer:nth-child(1)')
        .classList.add('active');
    });
    gsap.delayedCall(0.4, () => {
      document
        .querySelector('#form_screen .inputContainer:nth-child(2)')
        .classList.add('active');
    });
    gsap.delayedCall(0.5, () => {
      document
        .querySelector('#form_screen .inputContainer:nth-child(3)')
        .classList.add('active');
    });
    gsap.delayedCall(0.65, () => {
      document
        .querySelector('#form_screen .inputContainer:nth-child(4)')
        .classList.add('active');
    });
    gsap.delayedCall(0.9, () => {
      document
        .querySelector('#form_screen .btn_container')
        .classList.add('active');
    });
  }
  onSubmit() {
    if (this.isSubmitted) return;
    if (this.bool) return;
    this.bool = true;

    let name = document.getElementById('name').value;
    let email = document.getElementById('email').value;
    let country = document.getElementById('country').value;
    let mobile = document.getElementById('mobile').value;
    document.getElementById('error').style.display = 'none';
    const name_regx = /[0-9!@#$%^&*()+=._-]/;
    const regex = new RegExp(
      '^[a-zA-Z0-9_.+\\-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9]{2,4}$'
    );

    let err = '';
    if (name == '' || name.length < 1 || name.length > 30) {
      err = Lang['errorName'][Global.lang];
    } else if (email == '' || email == null) {
      err = Lang['errorEmail'][Global.lang];
    } else if (!regex.test(email)) {
      err = Lang['errorEmail'][Global.lang];
    } else if (country == '' || country == null) {
      err = Lang['errorCountry'][Global.lang];
    } else if (
      !mobile ||
      mobile.trim() === '' ||
      isNaN(mobile) ||
      mobile.length < 7 ||
      mobile.length > 11
    ) {
      err = Lang['errorMobile'][Global.lang];
    } /*  else if (isNaN(mobile)) {
      err = Lang['errorMobile'][Global.lang];
    } else if (mobile.length < 7 || mobile.length > 11) {
      err = Lang['errorMobile'][Global.lang];
    } */

    if (err != '') {
      this.showError(err);
      return;
    }
    this.hideScreen();
    this.isSubmitted = true;
    Global.name = name;
    Global.email = email;
    Global.country = country;
    Global.mobile = Global.countryCode + mobile;

    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'registerNextClick',
      uniqID: Global.U_ID,
    });
    Global.serverObj.send(
      `${Global.BASE_URL}webservice.php`,
      (response) => {
        // response = JSON.parse(response)
      },
      null,
      {
        name: Global.name,
        email: Global.email,
        country: Global.country,
        mobile: Global.mobile,
        saveType: 'saveForm',
        utm_source: Global.utm_source,
        uniqID: Global.U_ID,
      },
      'POST',
      null,
      false
    );
  }
  hideScreen() {
    gsap.delayedCall(0.0, () => {
      document.querySelector('#form_screen .logo').classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#form_screen #details')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#form_screen .inputContainer:nth-child(1)')
        .classList.remove('active');
    });
    gsap.delayedCall(0.2, () => {
      document
        .querySelector('#form_screen .inputContainer:nth-child(2)')
        .classList.remove('active');
    });
    gsap.delayedCall(0.3, () => {
      document
        .querySelector('#form_screen .inputContainer:nth-child(3)')
        .classList.remove('active');
    });
    gsap.delayedCall(0.45, () => {
      document
        .querySelector('#form_screen .inputContainer:nth-child(4)')
        .classList.remove('active');
    });
    gsap.delayedCall(0.7, () => {
      document
        .querySelector('#form_screen .btn_container')
        .classList.remove('active');
    });

    gsap.delayedCall(1.2, () => {
      document.querySelector('#form_screen').classList.remove('active');
      document.querySelector('#form_screen').classList.remove('active2');
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_screen',
          data: {
            screenKey: 'UploadScreen',
          },
        },
      });
    });
  }
  showError(err) {
    this.bool = false;
    document.querySelector('.errorSec').innerHTML = err;
    document.querySelector('.errorSec').classList.add('active');
    this.errorTO && clearTimeout(this.errorTO);
    this.errorTO = setTimeout(() => {
      document.querySelector('.errorSec').classList.remove('active');
    }, 1000);
    // document.getElementById('error').innerHTML = err;
    // document.getElementById('error').style.display = 'block';
  }
  changeCountry(value) {
    switch (value) {
      case 'UAE':
        Global.countryCode = '+971';
        break;

      case 'KSA':
        Global.countryCode = '+966';
        break;

      case 'Morocco':
        Global.countryCode = '+212';
        break;
      case 'Iraq':
        Global.countryCode = '+964';
        break;
      case 'Jordan':
        Global.countryCode = '+962';
        break;
      case 'Lebanon':
        Global.countryCode = '+961';
        break;
      case 'Palestine':
        Global.countryCode = '+970';
        break;
      case 'Kuwait':
        Global.countryCode = '+965';
        break;
      case 'Oman':
        Global.countryCode = '+968';
        break;
      case 'Bahrain':
        Global.countryCode = '+973';
        break;
      case 'Qatar':
        Global.countryCode = '+974';
        break;
      case 'Egypt':
        Global.countryCode = '+20';
        break;
      case 'Libya':
        Global.countryCode = '+218';
        break;
      case 'Réunion':
        Global.countryCode = '+262';
        break;
      case 'Mauritius':
        Global.countryCode = '+230';
        break;
      default:
        Global.countryCode = '';
        break;
    }
    document.getElementById('prifix').innerHTML = Global.countryCode;
  }
}
